// TODO: rename to "TableActions" and couple to Tables
import React from 'react';
import PropTypes from 'prop-types';

import { Box } from '@material-ui/core';

const Actions = ({ children, ...props }) => {
  // NOTE: This component is a simple placeholder container that can be expanded later if needed.
  return <Box {...props}>{children}</Box>;
};

Actions.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,
};

Actions.defaultProps = {};

export default Actions;
